import { EditorEvents, useCurrentEditor } from '@tiptap/react';
import { useEffect, useState } from 'react';

export default function useIsEditorEditable() {
  const { editor } = useCurrentEditor();
  const [isEditable, setIsEditable] = useState(editor?.isEditable ?? false);
  useEffect(() => {
    if (!editor) return;
    setIsEditable(editor.isEditable);
    function handleIsEditableChange({ editor }: EditorEvents['update']) {
      setIsEditable(editor.isEditable);
    }
    editor.on('update', handleIsEditableChange);
    return () => {
      editor.off('update', handleIsEditableChange);
    };
  }, [editor]);

  return isEditable;
}
